import { render, staticRenderFns } from "./20220830.vue?vue&type=template&id=8e3271d4"
import script from "./20220830.vue?vue&type=script&lang=js"
export * from "./20220830.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports